







































import mixins from 'vue-typed-mixins';
import {
  ReportNode,
  SectionData,
  QuestionData,
  ReportContext,
} from '@/utils/ReportUtils';
import Page from './Page.vue';
import SurveyUtils, { Section, Question } from '@/utils/SurveyUtils';
import { SubOrganization } from '@/utils/SubOrganizationUtils';
import SurveyNodeUtils from '@/utils/SurveyNodeUtils';
export default mixins().extend({
  name: 'node_section',

  components: {
    node_page: Page,
  },

  props: {
    node: {
      type: Object as () => ReportNode<Section, SectionData>,
    },

    context: {
      type: Object as () => ReportContext,
    },

    suborganization: {
      type: Object as () => SubOrganization,
    },
  },

  computed: {
    visible(): boolean {
      return this.node?.data?.visible || false;
    },

    displayChildren(): boolean {
      return (
        !this.suborgSelector ||
        this.hasSuborg === false ||
        (this.suborgSelector &&
          this.hasSuborg !== undefined &&
          this.suborganizationInternal !== undefined)
      );
    },

    suborganizationSelector(): any {
      return {
        label:
          this.$translate(this.context.survey?.languageobjects?.suborg) ||
          this.$tc('model.survey.suborg'),
        items: this.context?.suborganizations?.map((suborganization) => ({
          text: this.$translate(suborganization.name),
          value: suborganization,
        })),
      };
    },

    suborganizationInternal: {
      get(): SubOrganization | undefined {
        if (!this.hasSuborg || this.node?.item?.level !== 'suborg') {
          return undefined;
        }
        return this.context?.currentSubOrg;
      },
      set(suborganization: SubOrganization) {
        if (this.node) {
          this.context.currentSubOrg = suborganization;
        }
      },
    },

    hasSuborg(): boolean {
      return (
        !!this.context?.suborganizations &&
        this.context?.suborganizations.length > 0
      );
    },

    suborgSelector(): boolean {
      return (
        this.node?.item?.level === 'suborg'
        // this.value.node?.item?.scope === 'page'
      );
    },

    suborgTitle(): string {
      return this.$translate(this.context.survey?.languageobjects?.suborg) ||
          this.$tc('model.survey.suborg');
    },

    children(): ReportNode | undefined {
      if (this.context.nodes) {
        const path = SurveyNodeUtils.parsePath(
          this.context.path,
          this.context.nodes
        );

        // find the current location in the path array
        const index = path.findIndex((node) => node.uuid === this.node?.uuid);

        // visible child is the next element in the path array
        if (index >= 0 && index + 1 < path.length) {
          return path[index + 1];
        }
      }
    },
  },

  mounted() {
    if (this.hasSuborg && this.suborgSelector) {
      if (
        this.node &&
        this.context.suborganizations &&
        this.context.suborganizations.length > 0
      ) {
        // this.node.data.suborganization = this.context.suborganizations[0];
      } else if (
        this.node &&
        this.context.suborganizations &&
        this.context.suborganizations.length <= 0
      ) {
        this.node.data.suborganization = undefined;
      }
    }
  },
});
